import React, { useState, useEffect } from "react";
import Navigation from "./Navigation";
import PublicationRibbon from "./PublicationRibbon";
import HeroSection from "./HeroSection";
import StatsBar from "./StatsBar";
import TeamSection from "./TeamSection";
import DemoSection from "./DemoSection";
import ProductsSection from "./ProductsSection";
import ActiveInitiativesSection from "./ActiveInitiativesSection";
import ResearchSection from "./ResearchSection";
import PartnersSection from "./PartnersSection";
import ContactSection from "./ContactSection";
import SplashIntro from "./SplashIntro";
import { useSiteContent } from "../contexts/SiteContentContext";
import { trackVisit } from "../lib/visitorTracker";

const HomePage = () => {
  const [activeSection, setActiveSection] = useState("home");
  const { visibility } = useSiteContent();

  useEffect(() => {
    trackVisit();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "home",
        "team",
        "products",
        "initiatives",
        "demo",
        "research",
        "contact",
      ];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#EFE7D5]">
      <SplashIntro />
      <PublicationRibbon />
      <Navigation activeSection={activeSection} />
      {visibility.hero !== false && <HeroSection />}
      {visibility.stats !== false && <StatsBar />}
      {visibility.team !== false && <TeamSection />}
      {visibility.products !== false && <ProductsSection />}
      {visibility.initiatives !== false && <ActiveInitiativesSection />}
      {visibility.demo !== false && <DemoSection />}
      {visibility.research !== false && <ResearchSection />}
      {visibility.partners !== false && <PartnersSection />}
      {visibility.contact !== false && <ContactSection />}
    </div>
  );
};

export default HomePage;
